module.exports = __webpack_public_path__ + "static/media/iconfont.372b88a4.woff";